import Image from "../rest/Image";

/** Те же данные для `PreviewPhotos`, что и в TakeOrder.showPrev (canvas превью / URL). */
export function buildOrderPreviewPhotosFromFiles(files) {
    if (!Array.isArray(files)) {
        return [];
    }
    const meme = files.filter((x) => x && x.delete !== true);
    return meme.map((item) => {
        const bordersMode = item && item.borders ? item.borders : "Без полей";
        const resultCanvas =
            bordersMode === "С полями" ? item.canvas : (item.canvas_noborders || item.canvas_bz);
        let url = Image.getDisplayUrl(item.photo, item.previewThumb);
        const canvasOk =
            resultCanvas &&
            typeof resultCanvas.toDataURL === "function" &&
            resultCanvas.width > 1 &&
            resultCanvas.height > 1;
        if (canvasOk) {
            try {
                url = resultCanvas.toDataURL("image/jpeg", 0.9);
            } catch (e) {
                url = Image.getDisplayUrl(item.photo, item.previewThumb);
            }
        }
        return {
            ...item,
            url,
            cnv: resultCanvas || {width: item?.imageSize?.width || 1, height: item?.imageSize?.height || 1}
        };
    });
}
